module.exports = __webpack_public_path__ + "media/product_quotes/footer_bg-657111e6.png";